<template>
<div class="navBox" :style="{ background: topBj,color: topColor }">
  <span v-if="leftShow" class="leftBox" @click="onClickLeft"><van-icon :style="{ color: topColor }" name="arrow-left" />{{ leftText }}</span>
  <span class="titleBox">{{ title }}</span>
  <span class="titleRight"> 
    <van-badge :content="unreadMessageCount" :max="99" color="#1989fa" class="badgeIcon" />
    <van-icon @click="onSeeMessage" name="chat-o" size="0.7rem" style="margin-right: 0.16rem;" />
    <van-icon @click="onSeeMy" name="manager-o" size="0.7rem" />
  </span>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: { 
    leftShow: { 
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    leftText: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    }, 
    // 顶部背景色
    topBj: { 
      type: String,
      default: '#ff0000',
    },  
    topColor: { 
      type: String,
      default: '#ff0000',
    },  
    // 返回链接
    backUrl: { 
      type: String,
      default: '',
    }
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters([
      'unreadMessageCount'
    ])
  },
  created() {

  }, 
  methods: {
    onClickLeft() { 
      if(this.backUrl) { 
        if(this.backUrl === 'back') { 
          this.$router.back()
        } else { 
          this.$router.push(this.backUrl)
        }
      } else { 
        this.$router.push('/')
      }
      this.$emit('clickLeft')
    },
    onClickRight() {
      this.$emit('clickRight')
    },
    onSeeMessage() {
      this.$router.push('/message')
    },
    onSeeMy() {
      this.$router.push('/my')
    }
  }
}
</script>

<style lang="less">
.navBox {
  position: relative;
  z-index: 99;
  font-size: 0.56rem; 
  line-height: 1.2rem;
  height: 1.2rem;
  width: 100%;
  position: fixed;
  >span { 
    display: inline-block;
    text-align: center;
  }
  .leftBox {
    width: 2.1rem;
    color: #333;
    font-size: 0.52rem; 
    margin-left: 0.3rem;
    text-align: left;
  }
  .titleBox { 
    position: absolute;
    width: 100%;
    line-height: 1.2rem;
    left: 0;
    z-index: -1;
  }
  .titleRight { 
    position: absolute;
    right: 0.3rem;
    line-height: 1.2rem;
    .badgeIcon { 
      position: absolute;
      top: 0.1rem;
      left: -0.32rem;
    }
  }
}
</style>